import MobileWordmark from "./MobileWordmark";
import { LuTrophy } from "react-icons/lu";
import { createContext, useContext, useId, useLayoutEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LuArrowLeft as FiArrowLeft, LuBell as FiBell, LuSettings as FiSettings, LuUsers as FiUsers, LuPlus as FiPlus } from "react-icons/lu";
import { useUser } from "../contexts/UserContext";
import { rows, useRecord } from "../utils/appData";
import "./MobileHeader.css";

export const MobileHeaderRegistration = createContext(null);

function HomeActions() {
  const { currentUser } = useUser();
  const { data } = useRecord(
    currentUser?.uid ? `Notifications/${currentUser.uid}` : null,
  );
  const count = rows(data).filter((item) => item.read !== true).length;
  return (
    <>
      <Link className="app-header-challenge" to="/apply-challenge">
        <LuTrophy size={14} />
        <span>Challenge</span>
      </Link>
      <Link
        className="app-header-action"
        to="/notifications"
        aria-label={`Notifications, ${count} unread`}
      >
        <FiBell size={18} />
        {count > 0 && (
          <span className="app-header-badge">{count > 99 ? "99+" : count}</span>
        )}
      </Link>
    </>
  );
}

export function MobileHeaderView({
  title,
  isBackBtn,
  handleBack,
  onBack,
  rightElement,
  variant,
  backgroundColor,
}) {
  const navigate = useNavigate();
  const { currentUser } = useUser();
  const { pathname } = useLocation();
  const primary = ["/dashboard", "/discover", "/chats", "/profile"].includes(
    pathname,
  );
  const mode =
    variant ||
    (pathname === "/dashboard"
      ? "home"
      : isBackBtn
        ? "sub"
        : primary
          ? "tab"
          : "sub");
  const label = title === "Chat" ? "Messages" : title;
  let actions = rightElement;
  if (actions == null && mode === "home") actions = <HomeActions />;
  if (actions == null && pathname === "/profile")
    actions = (
      <Link className="app-header-action" to="/settings" aria-label="Settings">
        <FiSettings size={22} />
      </Link>
    );
  if (actions == null && pathname === "/discover")
    actions = (
      <Link className="app-header-friends" to="/notifications">
        <FiUsers size={17} />
        Friends
      </Link>
    );
  if (actions == null && pathname === "/chats")
    actions = (
      <Link
        className="app-header-action"
        to="/create-group"
        aria-label="Create group"
      >
        <FiPlus size={23} />
      </Link>
    );
  const back = () => {
    if (onBack || handleBack) return (onBack || handleBack)();
    if ((window.history.state?.idx || 0) > 0) navigate(-1);
    else navigate(currentUser ? "/dashboard" : "/", { replace: true });
  };
  return (
    <header
      className={`app-mobile-header app-mobile-header--${mode}`}
      style={backgroundColor ? { backgroundColor } : undefined}
      aria-label="Page header"
    >
      {mode === "sub" ? (
        <>
          <div className="app-header-side">
            <button
              className="app-header-back"
              onClick={back}
              aria-label="Go back"
            >
              <FiArrowLeft size={24} />
            </button>
          </div>
          <h1 className="app-header-subtitle" title={label}>
            {label || "Zylen"}
          </h1>
        </>
      ) : (
        <div className="app-header-heading">
          {mode === "home" ? (
            <Link
              className="app-header-wordmark"
              to="/dashboard"
              aria-label="Zylen home"
            >
              <MobileWordmark />
            </Link>
          ) : (
            <h1 className="app-header-tabtitle">{label || "Zylen"}</h1>
          )}
        </div>
      )}
      <div
        className={
          mode === "sub"
            ? "app-header-side app-header-right"
            : "app-header-right"
        }
      >
        {actions}
      </div>
    </header>
  );
}

export default function MobileHeader(props) {
  const register = useContext(MobileHeaderRegistration);
  const id = useId();
  const {
    title,
    isBackBtn,
    handleBack,
    onBack,
    rightElement,
    variant,
    backgroundColor,
  } = props;
  useLayoutEffect(() => {
    if (!register) return;
    return register(id, {
      title,
      isBackBtn,
      handleBack,
      onBack,
      rightElement,
      variant,
      backgroundColor,
    });
  }, [
    register,
    id,
    title,
    isBackBtn,
    handleBack,
    onBack,
    rightElement,
    variant,
    backgroundColor,
  ]);
  return register ? null : <MobileHeaderView {...props} />;
}
